export const getNumberValue = <T, K extends keyof T>(item: T | undefined, key: K): number => {
  const value = item?.[key]

  return Number(value) || 0
}
